/* VESPR — configurateur d'offre : Single $39.90 / Buy 2, Get 1 Free $79.80 (Most popular) / Buy 3, Get 2 Free $119.70 (Best value)
   v3 : délégation d'événements, animations, newsletter */
(function(){
  var SCENTS = [
    {id:"rowan", vid:58280658993496, handle:"rowan-body-butter", name:"ROWAN", insp:"Inspired by Tom Ford Oud Wood",     note:"oud, sandalwood, cardamom",            c:"#57685C", c2:"#96A899"},
    {id:"flint",    vid:58280659059032, handle:"flint-body-butter",    name:"FLINT",    insp:"Inspired by Dior Sauvage",        note:"bergamot, Sichuan pepper, dry amber", c:"#D0863F", c2:"#ecc884"},
    {id:"onyx",     vid:58280657060184, handle:"onyx-body-butter",     name:"ONYX",     insp:"Inspired by Louis Vuitton Ombré Nomade",   note:"saffron, oud, amber",            c:"#7A4B5C", c2:"#B98A98"},
    {id:"ember",     vid:58280659091800, handle:"ember-body-butter",     name:"EMBER",     insp:"Inspired by Tom Ford Tobacco Vanille",     note:"tobacco, vanilla, tonka",       c:"#A6402F", c2:"#D9755E"}
  ];
  var OFFERS = [
    {id:"single", qty:1, price:39.90, sub:31.92, name:"Single jar",        desc:"One scent. Test the hold.",        badge:null,             save:null,  freeIdx:null},
    {id:"trio",   qty:3, price:79.80, sub:null,  name:"Buy 2, Get 1 Free", desc:"3 jars — you pay for 2",           badge:"Most popular",   save:39.90, freeIdx:2},
    {id:"five",   qty:5, price:119.70,sub:null,  name:"Buy 3, Get 2 Free", desc:"All 4 scents, plus a second of your favourite", badge:"Best value", save:79.80, freeIdx:3}
  ];
  var SOLO = 39.90;   /* prix reel du pot unique — doit rester aligne sur OFFERS.single.price */
  /* Poids net imprime sur le pot. Sert au prix au gramme, le seul chiffre
     ou l'on gagne face a des pots de 125 g et 140 g vendus au meme prix. */
  var JAR_G = 200;

  /* ── Abonnement ──────────────────────────────────────────────────────────
     DESACTIVE tant qu'aucun selling plan n'existe cote Shopify. Verifie le
     25/08/2026 : sellingPlanGroups = [] sur la boutique ET sur le produit,
     selling_plan_allocations = 0 sur chaque variante. Le bouton 'Subscribe'
     affichait un prix reduit et facturait le tarif plein (+9,90 $ sur le
     trio, +13,10 $ sur la collection).
     Pour rouvrir : installer Shopify Subscriptions, creer le plan, renseigner
     SUB_PLAN_ID, passer SUBS_ENABLED a true — et transmettre selling_plan
     dans l'appel /cart/add.js du pont.
     SUBS_OFFERS ne contient que 'single' : un pot tient 6 a 10 semaines, donc
     un pack de 3 livre trois fois le rythme de consommation reel. */
  var SUBS_ENABLED = true;
  /* Identifiants des forfaits Shopify Subscriptions, groupe "Subscribe & never run out".
     Verifies le 25/08/2026 sur le storefront : les 3 allocations rendent 29,90 $. */
  var SUB_PLANS = { 6:"693311308120", 8:"693311340888", 12:"693311373656" }; /* clés = vraies fréquences Shopify */
  var SUBS_OFFERS  = ["single"];
  /* Seuil de livraison offerte, zone US (Shopify : "Amerique du Nord", 0 $ des 50 $).
     La mention est CALCULEE a partir de ce chiffre — si le seuil bouge, une seule ligne a changer. */
  var FREE_SHIP_US = 50;

  /* Sur une fiche parfum, le pot n.1 est celui de la page. Ailleurs, ordre par defaut. */
  function currentScentId(){
    var h = (location.pathname.match(/\/products\/([^\/?#]+)/)||[])[1] || "";
    for (var i=0;i<SCENTS.length;i++){ if(SCENTS[i].handle===h) return SCENTS[i].id; }
    return null;
  }
  function defaultJars(){
    var first = currentScentId();
    var rest = SCENTS.map(function(x){return x.id;}).filter(function(x){return x!==first;});
    return first ? [first].concat(rest) : SCENTS.map(function(x){return x.id;});
  }
  var state = { offer:"trio", jars:defaultJars(), mode:"onetime", freq:8 };

  /* Données partagées avec le cart drawer (cart.js) */
  window.VESPR_DATA = { SCENTS:SCENTS, OFFERS:OFFERS, SOLO:SOLO, SUB_PLANS:SUB_PLANS };

  function offer(){ return OFFERS.filter(function(o){return o.id===state.offer;})[0]; }
  function scent(id){ return SCENTS.filter(function(s){return s.id===id;})[0]; }
  function fmt(n){ return "$" + (Math.round(n*100)/100).toFixed(2).replace(/\.00$/,""); }
  /* centimes par gramme, une decimale */
  function perGram(price, qty){ return (Math.round((price*100)/(qty*JAR_G)*10)/10).toFixed(1); }

  var JAR_IMG = "";
  function readJarImg(){
    var el=document.getElementById("configurator");
    JAR_IMG = (el && el.getAttribute("data-jar-img")) || "";
  }

  function renderOffers(root){
    var g = root.querySelector(".offer-grid"); if(!g) return; g.innerHTML="";
    OFFERS.forEach(function(o){
      var b = document.createElement("button");
      b.type="button"; b.className="offer-opt"+(o.id===state.offer?" sel":"");
      b.setAttribute("data-offer",o.id);
      var per = o.price/o.qty;
      var jarTxt = o.qty + (o.qty>1 ? ' jars' : ' jar');
      b.innerHTML = '<span class="offer-thumb">'
        +   (JAR_IMG ? '<img src="'+JAR_IMG+'" alt="" loading="lazy" width="160" height="160">' : '')
        +   '<span class="offer-x">&times;'+o.qty+'</span>'
        + '</span>'
        + (o.badge?'<span class="offer-badge">'+o.badge+'</span>':'')
        + '<span class="offer-name">'+jarTxt+'</span>'
        + '<span class="offer-desc">'+o.name+'</span>'
        + '<span class="offer-price">'+fmt(o.price)+'</span>'
        + (o.save?'<span class="offer-cmp">'+fmt(o.qty*SOLO)+'</span>':'')
        + '<span class="offer-per">'+fmt(o.price/o.qty)+' / jar</span>'
        + (o.save?'<span class="offer-save">Save '+fmt(o.save)+'</span>':'')
        /* prix reellement paye : o.sub vaut null sur les packs, et Math.min(x, null) donne 0 */
        + (((o.sub != null ? Math.min(o.price, o.sub) : o.price) >= FREE_SHIP_US) ? '<span class="offer-ship">Free shipping</span>' : '');
      g.appendChild(b);
    });
  }

  function renderJars(root){
    var o = offer();
    var wrap = root.querySelector(".cfg-scents");
    var single = (o.qty === 1);

    /* Pot unique : il n'y a rien a choisir, on est deja sur la fiche du parfum. */
    if(single){ state.jars[0] = currentScentId() || state.jars[0] || SCENTS[0].id; }

    var rows = root.querySelector(".jar-rows");
    if(rows){
      rows.innerHTML = "";
      if(!single){
        for(var i=0;i<o.qty;i++){
          if(state.jars[i]===undefined) state.jars[i]=SCENTS[i%4].id;
          /* nombre de pots offerts deduit de l'economie : trio -> 1, pack de 5 -> 2 */
          var freeCount = o.save ? Math.round(o.save / SOLO) : 0;
          var isFree = freeCount > 0 && i >= (o.qty - freeCount);
          var cur = scent(state.jars[i]);
          var row=document.createElement("div"); row.className="jar-row";
          var opts = SCENTS.map(function(sc){
            return '<option value="'+sc.id+'"'+(state.jars[i]===sc.id?' selected':'')+'>'
                 + sc.name+' \u00b7 '+sc.insp+'</option>';
          }).join('');
          row.innerHTML = '<span class="jar-num">Jar '+(i+1)+(isFree?' <i class="jar-free">free</i>':'')+'</span>'
            + '<span class="jar-pick" style="--cc:'+cur.c+'">'
            +   '<select data-j="'+i+'" aria-label="Scent for jar '+(i+1)+'">'+opts+'</select>'
            + '</span>';
          rows.appendChild(row);
        }
      }
    }

    /* Rappel permanent : quel nom correspond a quel parfum et a quelles notes. */
    var hint = root.querySelector(".jars-hint");
    if(hint){
      hint.innerHTML = SCENTS.map(function(sc){
        return '<span class="skey"><i style="background:'+sc.c+'"></i>'
             + '<b>'+sc.name+'</b>'
             + '<u>'+sc.insp+'</u>'
             + '<em>'+sc.note+'</em></span>';
      }).join('');
    }

    /* Resume dans l'entete du bloc repliable */
    var sum = root.querySelector("[data-scent-summary]");
    if(sum){
      var c2={}; for(var j=0;j<o.qty;j++){ var n2=scent(state.jars[j]).name; c2[n2]=(c2[n2]||0)+1; }
      sum.textContent = Object.keys(c2).map(function(n){return (c2[n]>1?c2[n]+"\u00d7 ":"")+n;}).join(" \u00b7 ");
    }

    /* Sur le pot unique on masque tout le bloc de choix : rien a decider. */
    if(wrap){
      wrap.hidden = single;
      if(single) wrap.removeAttribute("open");
    }
  }

  function renderModes(root){
    var o = offer();
    var ot = root.querySelector('[data-mode="onetime"]'), sb = root.querySelector('[data-mode="sub"]');
    if(!ot||!sb) return;
    var subAllowed = SUBS_ENABLED && SUBS_OFFERS.indexOf(o.id) !== -1;
    if(!subAllowed && state.mode === "sub") state.mode = "onetime";
    sb.hidden = !subAllowed;
    var pm = sb.closest ? sb.closest(".purchase-modes") : null;
    if(pm){
      var title = pm.previousElementSibling;
      pm.hidden = !SUBS_ENABLED;
      if(title && title.classList && title.classList.contains("jars-title")) title.hidden = !SUBS_ENABLED;
    }
    ot.classList.toggle("sel",state.mode==="onetime");
    sb.classList.toggle("sel",state.mode==="sub");
    ot.querySelector(".pmode-price").textContent = fmt(o.price);
    sb.querySelector(".pmode-price").textContent = fmt(o.sub);
    var save = sb.querySelector(".pmode-save");
    if(save) save.textContent = "SAVE " + Math.round((o.price-o.sub)/o.price*100) + "%";
    var extra = root.querySelector(".cfg-sub-extra");
    if(extra) extra.classList.toggle("on", subAllowed && state.mode === "sub");
    root.querySelectorAll(".freq button").forEach(function(f){
      f.classList.toggle("on",parseInt(f.getAttribute("data-w"),10)===state.freq);
    });
  }

  function renderTotal(root, animate){
    var o = offer();
    var price = state.mode==="sub" ? o.sub : o.price;
    var cmp = o.qty*SOLO;
    var tp = root.querySelector(".total-price"); if(!tp) return;
    tp.innerHTML = fmt(price) + (price<cmp?'<span class="total-cmp">'+fmt(cmp)+'</span>':'');
    if(animate){
      tp.classList.remove("bump");
      void tp.offsetWidth; /* restart animation */
      tp.classList.add("bump");
    }
    var per = price/o.qty;
    var meta = fmt(per)+" / 200g jar";
    if(state.mode==="sub") meta += " · delivered every "+state.freq+" weeks · cancel anytime";
    root.querySelector(".total-meta").textContent = meta;
    var names = state.jars.slice(0,o.qty).map(function(id){return scent(id).name;});
    var cta = root.querySelector(".total-cta .btn");
    cta.textContent = (state.mode==="sub"?"Subscribe":"Add to cart")+" — "+fmt(price);
    cta.title = names.join(", ");
    var sticky=document.querySelector(".sticky-cta");
    if(sticky){
      sticky.querySelector(".p").textContent=fmt(price);
      sticky.querySelector(".s").textContent=o.qty+" jar"+(o.qty>1?"s":"")+" · "+fmt(per)+"/jar";
    }
  }

  function render(root, animate){
    renderOffers(root); renderJars(root); renderModes(root); renderTotal(root, animate);
  }

  function initConfigurator(){
    var root=document.getElementById("configurator");
    if(!root) return;
    readJarImg();

    /* ÉVÉNEMENTS EN DÉLÉGATION : un seul listener, survit à tous les re-renders */
    root.addEventListener("change",function(e){
      var sel = e.target.closest && e.target.closest("select[data-j]");
      if(sel){ state.jars[parseInt(sel.getAttribute("data-j"),10)] = sel.value; render(root,false); }
    });

    root.addEventListener("click",function(e){
      var offerBtn=e.target.closest(".offer-opt");
      if(offerBtn){ state.offer=offerBtn.getAttribute("data-offer"); render(root,true); return; }

      var chip=e.target.closest(".chip");
      if(chip){ state.jars[parseInt(chip.getAttribute("data-j"),10)]=chip.getAttribute("data-s"); render(root,false); return; }

      var freqBtn=e.target.closest(".freq button");
      if(freqBtn){ state.freq=parseInt(freqBtn.getAttribute("data-w"),10); state.mode="sub"; render(root,true); return; }

      var mode=e.target.closest(".pmode");
      if(mode && mode.getAttribute("data-mode")==="sub" && !SUBS_ENABLED) return;
      if(mode){ state.mode=mode.getAttribute("data-mode")==="sub"?"sub":"onetime"; render(root,true); return; }

      var addBtn=e.target.closest(".total-cta .btn");
      if(addBtn && window.VesprCart){
        var o=offer();
        window.VesprCart.addLine({ offer:o.id, jars:state.jars.slice(0,o.qty), mode:state.mode, freq:state.freq });
        return;
      }
    });

    render(root,false);

    /* sticky CTA mobile */
    var sticky=document.querySelector(".sticky-cta");
    if(sticky){
      window.addEventListener("scroll",function(){
        var r=root.getBoundingClientRect();
        sticky.classList.toggle("show", r.bottom<0 || r.top>window.innerHeight);
      },{passive:true});
      sticky.querySelector(".btn").addEventListener("click",function(){
        root.scrollIntoView({behavior:"smooth"});
      });
    }

    /* pré-sélection depuis les cartes parfums / pots hero */
    document.querySelectorAll("[data-pick-scent]").forEach(function(el){
      el.addEventListener("click",function(){
        state.offer="single"; state.jars[0]=el.getAttribute("data-pick-scent");
        render(root,true);
        root.scrollIntoView({behavior:"smooth"});
      });
    });
  }

  /* ===== Reveal au scroll ===== */
  function initReveal(){
    if(!("IntersectionObserver" in window)){ document.querySelectorAll(".rv").forEach(function(el){el.classList.add("in");}); return; }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add("in"); io.unobserve(en.target); }
      });
    },{threshold:.12,rootMargin:"0px 0px -40px 0px"});
    document.querySelectorAll(".rv").forEach(function(el){ io.observe(el); });
  }

  /* ===== Barre de tenue 8h : s'anime quand visible ===== */
  function initWearBar(){
    var bars=document.querySelectorAll(".wear");
    if(!bars.length) return;
    if(!("IntersectionObserver" in window)){ bars.forEach(function(b){b.classList.add("go");}); return; }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add("go"); io.unobserve(en.target); }
      });
    },{threshold:.4});
    bars.forEach(function(b){ io.observe(b); });
  }

  /* ===== Newsletter ===== */
  function initNewsletter(){
    document.querySelectorAll(".nl-form").forEach(function(form){
      form.addEventListener("submit",function(e){
        e.preventDefault();
        var input=form.querySelector('input[type="email"]');
        var email=(input.value||"").trim();
        if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){
          input.style.borderColor="var(--danger)";
          input.focus();
          return;
        }
        /* TODO Shopify : brancher sur le formulaire natif customer (contact[email], tags=newsletter)
           ou l'API Klaviyo — le code promo WELCOME10 doit être créé dans l'admin Shopify. */
        try{ localStorage.setItem("vespr_nl", email); }catch(_){}
        form.style.display="none";
        var ok=form.parentElement.querySelector(".nl-ok");
        if(ok) ok.style.display="block";
      });
      var input=form.querySelector('input[type="email"]');
      if(input) input.addEventListener("input",function(){ input.style.borderColor=""; });
    });
  }

  function init(){ initConfigurator(); initReveal(); initWearBar(); initNewsletter(); }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",init); else init();
})();
